
const newModel = () => {
    return {
        tinhTpId: null,
        ten: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        tinhTpId: null,
        ten: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        tinhTpId: item.tinhTpId,
        ten: item.ten,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        tinhTpId: item.tinhTpId,
        ten: item.ten,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        tinhTpId: null,
        ten: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const tinhTpModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


